import { Cell } from "./types";

const compareCells = (a: Cell, b: Cell): number => {
  if (a.minY < b.minY) {
    return -1;
  } else if (a.minY > b.minY) {
    return 1;
  }
  return a.minX - b.minX;
};

/*
const cellWithinOther = (cell: Cell, other: Cell): boolean =>
  !(
    cell.minX < other.minX ||
    cell.maxX > other.maxX ||
    cell.minY < other.minY ||
    cell.maxY > other.maxY
  );

const removeIntersectingZones = (cells: Array<Cell>): Array<Cell> => {
  return cells.reduce((prev, next, index) => {
    for (let i = 0; i < cells.length; i++) {
      if (i === index) {
        continue;
      }
      const comp = cells[i];
      if (cellWithinOther(next, comp)) {
        return prev;
      }
    }
    prev.push(next);
    return prev;
  }, [] as Array<Cell>);
};
*/

export const sortCells = (cells: Array<Cell>): Array<Cell> => {
  return cells.sort(compareCells);
};
